import LOCAL_STORAGE from "@/constants/local-storage";
import {
  IChangePassword,
  ILogin,
  ILoginTokens,
  IRecoverPassword,
  IRegister,
} from "@/interfaces/auth.interfaces";
import { apiT2B } from "@/lib/axios";
import internalAuthService from "./internal-auth.service";

class AuthService {
  private baseLoginUrl = "api/v1/login";
  private baseUserUrl = "api/v1/user";
  private baseSignupUrl = "api/v1/signup";

  async register(data: IRegister): Promise<ILoginTokens> {
    try {
      // Obter token de acesso interno para fazer a requisição de registro
      const internalAccessToken = await internalAuthService.getAccessToken();

      // Configurar headers com o token de acesso
      const config = {
        headers: {
          Authorization: `Bearer ${internalAccessToken}`,
        },
      };

      // Fazer a requisição com o token no header
      const response = await apiT2B.post(this.baseSignupUrl, data, config);
      return response.data;
    } catch (error) {
      console.error("Erro durante o registro:", error);
      throw error;
    }
  }

  async login(data: ILogin): Promise<ILoginTokens> {
    const response = await apiT2B.post(this.baseLoginUrl, data);
    return response.data;
  }

  async recoverPassword(data: IRecoverPassword): Promise<void> {
    await apiT2B.post(`${this.baseLoginUrl}/recoverpassword`, data);
  }

  async changePassword(data: IChangePassword): Promise<void> {
    await apiT2B.post(`${this.baseLoginUrl}/changepassword`, data);
  }

  async confirmEmail(token: string, customerId: string, userId: string): Promise<boolean> {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        CustomerId: customerId,
      },
    };

    try {
      await apiT2B.put(`${this.baseUserUrl}/${userId}/confirmemail`, {}, config);
      return true;
    } catch (error) {
      return false;
    }
  }

  async sendConfirmationEmail(token: string, customerId: string, userId: string): Promise<void> {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        CustomerId: customerId,
      },
    };
    await apiT2B.post(`${this.baseUserUrl}/${userId}/sendconfirmationemail`, {}, config);
  }

  async refreshToken(token: string): Promise<ILoginTokens> {
    const response = await apiT2B.post<ILoginTokens>(`${this.baseLoginUrl}/refreshtoken`, {
      refreshToken: token,
    });

    localStorage.setItem(LOCAL_STORAGE.accessTokenKey, response.data.accessToken);
    if (response.data.refreshToken) {
      localStorage.setItem(LOCAL_STORAGE.refreshTokenKey, response.data.refreshToken);
    }

    return response.data;
  }
}

const authService = new AuthService();
export default authService;
